module.exports = __webpack_public_path__ + "img/businessplan.7c4dbc10.jpeg";